import * as _4 from 'lodash4';
import { PlatformUtility } from 'utility-ts-platform';

export class AppContentComponent implements angular.IComponentOptions {
  public templateUrl: string = 'ui-ng-app-content/src/components/app_content/app_content.html';
  public controller: any = AppContentController;
  public transclude: any = true;
  public bindings: any = {
    hideNavBar: '<',
    hasFooter: '<',
    noPadding: '<',
    stickyNavBar: '<',
    refresher: '<'
  };
}

export class AppContentController {
  private hideNavBar: boolean;
  private hasFooter: boolean;
  private noPadding: boolean;
  private refresher: string;
  private stickyNavBar: boolean;

  get classes(): string {
    const activeClasses = PlatformUtility.isMobile() ? this.mobileClasses() : this.desktopClasses();
    return activeClasses.join(' ');
  }

  rootClass(): string {
    return PlatformUtility.isMobile() ? `app-content--mobile` : `app-content--desktop`;
  }

  mobileClasses(): string[] {
    const classes = [this.rootClass()];

    if (this.hideNavBar) {
      classes.push('hide-nav-bar');
    }

    if (this.hasFooter) {
      classes.push('has-footer');
    }

    if (!this.noPadding) {
      classes.push('plm prm');
    }

    if (_4.isEmpty(this.refresher)) {
      classes.push(this.refresher);
    }

    return classes;
  }

  desktopClasses(): string[] {
    const classes = [this.rootClass()];

    if (!this.noPadding) {
      classes.push('plm prm');
    }

    return classes;
  }

  isScrollableNavigation(): boolean {
    return PlatformUtility.isMobile() && !this.stickyNavBar;
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-app-content/src/components/app_content/app_content.ts